import { fetchData } from '@/utils/fetch'
import { toReject } from './util'

export const createCartOrder = toReject((data, options) => {
  return fetchData('/appb/b2b/order/placeCartOrder', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
})
